<template>
  <div class="sensitive-case container">
    <div class="sizer">
      <h2>{{ $t('environmentalDefinitionQuestion') }}</h2>
      <div class="entries">
        <div class="entry">
          <i class="material-icons">keyboard_arrow_right</i>
          <span v-if="environmentalMode === 0" class="description">
            {{ $t('environmentalDefinitionSegment1') }}
          </span>
          <span v-if="environmentalMode === 1" class="description">
            {{ $t('environmentalDefinitionSegment1Journey') }}
          </span>
          <span v-if="environmentalMode === 2" class="description">
            {{ $t('environmentalDefinitionSegment1Weighted') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    environmentalMode: {
      type: Number,
      default: 0,
    },
  },

  mounted() {
    console.log(this.environmentalMode);
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.sensitive-case {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .entries {
    display: flex;
    margin-top: 2em;

    .entry {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;

      & + .entry {
        margin-left: 13.75em;
      }

      i {
        color: colors.$main-color;
        font-size: 3em;
        position: absolute;
        right: 100%;
        top: 0;
      }

      .description {
        font-size: 2em;
        max-width: 60vw;
        height: 330px;
      }

      .data-value {
        font-size: 6.25em;
        font-weight: 300;

        small {
          font-size: 0.46em;
        }
      }
    }
  }
}

.main-content + .sensitive-case {
  font-size: 0.875em;
  justify-content: flex-start;

  .entries {
    flex-direction: column;

    .entry {
      flex-direction: row;
      align-items: flex-start;

      & + .entry {
        margin-left: 0em;
        margin-top: 1.3em;
      }

      i {
        position: relative;
        top: initial;
        right: initial;
      }

      .description {
        margin-right: 1em;
      }

      .data-value {
        line-height: 0.75em;
      }
    }
  }
}
</style>
